import { noop } from 'lodash';
import { useApi } from 'api/api-context';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';
import panic from 'errors/panic';
import { OnStatusChange, RevisionActionRevision } from 'components/tables/data/revision/types';

/**
 * Implements the accept delegation action for revision.
 */
export default function useAcceptDelegationAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to accept the delegation.
   */
  async function acceptDelegation({
    revision,
    onStatusChange = noop,
  }: {
    revision: RevisionActionRevision;
    onStatusChange?: OnStatusChange;
  }) {
    const revisionDelegateAcceptAction = getAction('RevisionDelegateAccept');

    try {
      await revisionDelegateAcceptAction({ parameters: { revisionId: String(revision.revisionId) } });

      // Refresh the revision data
      onStatusChange({ revisionId: revision.revisionId, status: revision.revisionStatus });

      showNotification({
        title: 'Delegovanie prijaté',
        message:
          revision.kind === 'revision'
            ? `Delegovanie revíznej správy ${revision.revisionName} ste úspešne prijali.`
            : `Delegovanie formulára ${revision.revisionName} ste úspešne prijali.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { acceptDelegation };
}
